var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('brand-assets-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var campaign = ref.campaign;
var proposal = ref.proposal;
var proposalStep = ref.proposalStep;
var goNextStep = ref.goNextStep;
var goPreviousStep = ref.goPreviousStep;
var isLoading = ref.isLoading;
var isCompletingProposal = ref.isCompletingProposal;
return [_c('proposal-assets-view',{attrs:{"campaign":campaign,"proposal-step":proposalStep,"proposal":proposal,"is-loading":isLoading,"is-completing-proposal":isCompletingProposal},on:{"go-next-step":goNextStep,"go-previous-step":goPreviousStep}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }